import { CollectionTemplateDefinitionField, FieldType } from '@indigohive/cogfy-types'
import { createElement } from 'react'
import { SparklesIcon } from 'lucide-react'
import { MIN_FIELD_WIDTH } from './CollectionTemplateTable'
import { FIELD_ICONS_BY_TYPE } from './field-type-icons'

export type CollectionTemplateTableFieldProps = {
  field: CollectionTemplateDefinitionField | undefined
  config?: any | null
}

export function CollectionTemplateTableField (props: CollectionTemplateTableFieldProps) {
  const { field, config } = props

  if (!field) return

  const configuredWidth = config?.ui?.width ? (config?.ui?.width - 40) : MIN_FIELD_WIDTH
  const width = configuredWidth < MIN_FIELD_WIDTH
    ? MIN_FIELD_WIDTH
    : configuredWidth

  return (
    <div
      className='border-r border-neutral/40 relative h-full gap-3 px-2 cursor-pointer hover:bg-slate-100 truncate'
      style={{ width: width + 'px' }}
    >
      <div className="flex justify-between items-center h-full overflow-hidden max-w-full whitespace-nowrap gap-2">
        <span className='inline-flex items-center gap-1.5 text-sm'>
          {createElement(
            FIELD_ICONS_BY_TYPE[field.type as FieldType],
            { size: 13 }
          )}
          {field?.name}
        </span>

        <span className="flex text-gray-400">
          {field?.operation && <SparklesIcon size={13} />}
        </span>
      </div>
    </div>
  )
}
